import * as angular from "angular";

export class PublicApiService {
    private v2ApiRoot: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2ApiRoot = "/v2/public_api";
    }

    all(): Promise<object> {
        return this.$http.get(this.v2ApiRoot + "/all");
    }

    all_access_tokens(): Promise<object> {
        return this.$http.get(this.v2ApiRoot + "/all_access_tokens");
    }

    create_access_token(): Promise<object> {
        return this.$http.post(this.v2ApiRoot + "/create_access_token");
    }

    revoke_access_token(data: {
        id: string;
        uid: string | number;
    }): Promise<object> {
        return this.$http.post(
            this.v2ApiRoot + `/revoke_access_token/${data.id}`,
            data
        );
    }
}

angular.module("vcServices").service("PublicApiService", PublicApiService);
